import { MultiSelect } from "@mantine/core";

import { IconSearch } from "@tabler/icons-react";

import { TextWrapper } from "@/components/TextWrapper";

import {
  MISSING_SERVICES_PROVIDER_FILTER_LOADING_PLACEHOLDER,
  MISSING_SERVICES_PROVIDER_FILTER_PLACEHOLDER,
  MISSING_SERVICES_PROVIDER_FILTER_TESTID,
  MISSING_SERVICES_PROVIDER_FILTER_TITLE,
} from "./constants/missing-services";
import { MissingServicesFilterProviderSectionProps } from "./types/missing-services";

/**
 * The Filter Services drawer's Provider section: one searchable multi-select instead of a checkbox
 * per Practitioner. A practice can hold dozens of eligible signers, which made the checkbox list the
 * tallest thing in the drawer and pushed Encounter and By Status out of view; a multi-select keeps
 * the section a fixed height and lets the user type a name instead of scanning for it.
 *
 * The input stays mounted while providers load, disabled and with a loading placeholder, rather than
 * swapping in a spinner — the drawer fetches on open, so a spinner here would resize the section
 * under the user as the list arrives.
 */
export default function MissingServicesFilterProviderSection({
  providers,
  selectedIds,
  onSelectionChange,
  isLoading,
}: MissingServicesFilterProviderSectionProps) {
  return (
    <MultiSelect
      clearable
      searchable
      value={selectedIds}
      disabled={isLoading}
      onChange={onSelectionChange}
      rightSection={<IconSearch size={18} />}
      nothingFoundMessage="No providers found"
      data-testid={MISSING_SERVICES_PROVIDER_FILTER_TESTID}
      data={providers.map((provider) => ({ value: provider.id, label: provider.label }))}
      label={
        <TextWrapper size="md" c="dark.9" variant="bold">
          {MISSING_SERVICES_PROVIDER_FILTER_TITLE}
        </TextWrapper>
      }
      placeholder={
        isLoading
          ? MISSING_SERVICES_PROVIDER_FILTER_LOADING_PLACEHOLDER
          : MISSING_SERVICES_PROVIDER_FILTER_PLACEHOLDER
      }
    />
  );
}
